import { Injectable } from '@angular/core';

import { Observable, map } from 'rxjs';

import { MenuAccessService as InternetBankingMenuAccessService, Pages } from '@foo/internet-banking-web-framework/shared-core';


@Injectable({
  providedIn: 'root'
})
export class MenuAccessService extends InternetBankingMenuAccessService {
  getItemList(types: string[] = ["more_page", "quick_action"]): Observable<Pages> {
    return super.getItemList(types).pipe(
      map((pages: Pages) => {
        pages.items.more_page = pages.items.more_page?.filter(page => page.key !== 'more.get_statements');
        return pages;
      })
    );
  }

}
